import React, { useContext } from "react";
import AppCurrentLangContext from "@/contexts/appCurrentLang.context";
import AreFlagsDisplayedContext from "@/contexts/areFlagsDisplayed.context";
import transparentDivContext from "@/contexts/transparentDiv.context";
import styles from "./AppLangChoice.module.scss";
import {
  LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE,
  arrayLangsInApp,
} from "@/modules/i18n/i18n.consts";
import LinkMenu from "../ResponsiveMenu/LinkMenu/LinkMenu";
import { LangObject } from "@/modules/i18n/types/i18n.types";
import { useTranslation } from "@/modules/i18n/i18n.hooks";
import OutlineIcon from "@/assets/svg/arrow_drop_down/outline.svg";

const AppLangChoice = () => {
  const { t } = useTranslation();
  const { appCurrentLang, setAppCurrentLang } = useContext(
    AppCurrentLangContext,
  );
  const { isTransparentDivDisplayed, setIsTransparentDivDisplayed } =
    useContext(transparentDivContext);

  const { areFlagsDisplayed, setAreFlagsDisplayed } = useContext(
    AreFlagsDisplayedContext,
  );

  const handleClick = (lang: LangObject) => {
    setIsTransparentDivDisplayed(false);
    setAreFlagsDisplayed(false);
    setAppCurrentLang({
      locale: lang?.locale,
      translatedText: lang?.translatedText,
      pictureName: lang?.pictureName,
      langID: lang?.langID,
    });

    window.localStorage.setItem(
      LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE,
      lang?.locale,
    );
  };

  const handleClickDisplayFlags = () => {
    setAreFlagsDisplayed(!areFlagsDisplayed);
    setIsTransparentDivDisplayed(!isTransparentDivDisplayed);
  };

  const urlPicture = "/pictures/flags/" + appCurrentLang?.pictureName + ".png";
  const currentLanguageLabel =
    appCurrentLang?.locale === "fr-FR"
      ? t("generic.language.french", "French")
      : t("generic.language.english", "English");

  const getLanguageLabel = (lang: LangObject) =>
    lang.locale === "fr-FR"
      ? t("generic.language.french", "French")
      : t("generic.language.english", "English");

  // code d'easyflow pas utilisé ici, à voir si on en a besoin si le drapeau a du mal à se rerendre
  // Updating directly the DOM because DOm from SSR can be different from data in memory, and HTML can miss an update sometimes.
  if (typeof window !== "undefined") {
    const imageFlag = window.document.getElementById(
      "currentFlag",
    ) as HTMLImageElement;
    const urlFlagDOM = imageFlag?.src;

    if (
      urlFlagDOM !== urlPicture &&
      urlFlagDOM !== null &&
      urlFlagDOM !== undefined
    ) {
      imageFlag.src = urlPicture;
    }
  }

  return (
    <div className={styles.currentAppLang}>
      <button
        type="button"
        className={styles.currentLangFlag}
        onClick={handleClickDisplayFlags}
        aria-haspopup="listbox"
        aria-expanded={areFlagsDisplayed}
        aria-label={currentLanguageLabel}
      >
        {appCurrentLang?.pictureName && (
          <img
            src={urlPicture}
            alt={appCurrentLang?.pictureName + " flag"}
            id="currentFlag"
            className={styles.currentFlagImage}
          />
        )}
        <span className={styles.currentLangLabel}>{currentLanguageLabel}</span>
        <div
          className={`${styles.arrowIcon} ${areFlagsDisplayed ? styles.arrowIconOpen : ""}`}
        >
          <OutlineIcon />
        </div>
      </button>

      {areFlagsDisplayed && (
        <div className={styles.setLangChoosing} role="listbox">
          {arrayLangsInApp.map((lang, index) => (
            <div
              className={`${styles.flagDropDown} ${
                appCurrentLang?.locale === lang.locale
                  ? styles.flagDropDownActive
                  : ""
              }`}
              key={index}
              onClick={() => handleClick(lang)}
            >
              <LinkMenu className={styles.flagDropDownInner}>
                <div className={styles.optionFlagWrap}>
                  <img
                    src={"/pictures/flags/" + lang?.pictureName + ".png"}
                    alt={lang?.pictureName + " flag"}
                    className={styles.optionFlagImage}
                  />
                </div>
                <span className={styles.optionLabel}>
                  {getLanguageLabel(lang)}
                </span>
              </LinkMenu>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AppLangChoice;
